import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Yii } from 'libraries/interfaces/Yii';
import { ILanguageCodeValue } from 'libraries/pipes/localized/localized.interface';
import { IFareFamilyDictionary } from 'libraries/service/resources/airTrip/IGetAirTripQuotes';
import { BtnStyleTypes } from 'libraries/ui_button/btn.component';
import { FareFamilyService } from './fare-family.service';
import { FareFamilyType } from "@afidium/ts-facade";


export interface IFareFamilyDialogData{
    dictionary: FareFamilyType;
    isSelected?: boolean;
    price?: {
        value: string | number;
        priceDifference?: string;
        currencyCode?: string;
        decimals?: number;
    };
}

class ComponentWording{
    public readonly fareFamilyDescription: string = Yii.t('wui-iqba-js', "Descriptif de la Fare Family");
    public readonly fareFamiliesDescription: string = Yii.t('wui-iqba-js', "Descriptif des Fare Family");
    public readonly otherQuotes: string = Yii.t('wui-iqba-js', "Autres offres");
    public readonly close: string = Yii.t('wui-iqba-js', "Fermer");
}

@Component({
    selector: 'fare-family-description-dialog',
    template: `
        <card>
            <ng-container class="card-header-content">
                <p class="flex-1">{{ data.length > 0 ? wording.fareFamilyDescription : wording.fareFamiliesDescription }}</p>
                <btn [label]="wording.close"
                    [type]="btnStyleTypes.actionLink"
                    (click)="closeModal()"></btn>
            </ng-container>
            <ng-container class="card-body-content padded">
                <div *ngFor="let fareFamily of data; trackBy: trackByfn; let last = last"
                    class="ctn ctn-right-left"
                    [class.last]="last">
                    <main class="flex-1"
                        [class.is-selected]="fareFamily.isSelected">
                        <h3 class="padded">
                            <span> {{ getFareFamilyName(fareFamily.dictionary) }} </span>
                            <div class="price-in-title" *ngIf="fareFamily?.price">
                                <price
                                    [value]="fareFamily.price.value"
                                    [currency]="fareFamily.price.currencyCode">
                                </price>
                                <delta-price classList="center-price"
                                    [oldPrice]="selectedFareFamily.price"
                                    [price]="getCurrentPriceForDelta(fareFamily.price)"
                                    [currency]="selectedFareFamily.currency"></delta-price>
                            </div>
                        </h3>
                        <div *ngIf="fareFamily.dictionary.description?.textLineArray?.length"
                            class="padded">
                            <p *ngFor="let textLine of fareFamily.dictionary.description.textLineArray; trackBy: trackByfn">
                                {{ textLine }}
                            </p>
                        </div>
                        <ng-container *ngIf="fareFamily.dictionary.descriptionArray?.length">
                            <div *ngFor="let description of fareFamily.dictionary.descriptionArray"
                                class="padded">
                                <p *ngIf="description.title"><strong>{{ description.title }}</strong></p>
                                <ng-container *ngIf="description.textLineArray?.length">
                                    <p *ngFor="let textLine of description.textLineArray; trackBy: trackByfn">
                                        {{ textLine }}
                                    </p>
                                </ng-container>

                            </div>
                        </ng-container>
                    </main>
                    <aside class="padded" *ngIf="fareFamily.dictionary.media?.imageArray?.length">
                        <div *ngFor="let media of fareFamily.dictionary.media.imageArray; trackBy: trackByfn">
                            <img [src]="media.url">
                        </div>
                    </aside>
                </div>
            </ng-container>
        </card>
    `,
    styleUrls: ["./fare-family-description-dialog.component.scss"]
})

export class FareFamilyDescriptionDialogComponent implements OnInit{

    public wording: ComponentWording = new ComponentWording();
    public readonly btnStyleTypes: typeof BtnStyleTypes = BtnStyleTypes;
    public fareFamilyName: string;
    public selectedFareFamily: {
        xId: string,
        price: { [key: string]: number; };
        currency: { code: string; decimals: number; }
    };

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: IFareFamilyDialogData[],
        private readonly dialogRef: MatDialogRef<FareFamilyDescriptionDialogComponent>,
        private readonly fareFamilyService: FareFamilyService,
    ){}

    public ngOnInit(): void{
        this.getSelectedFareFamily();
    }

    public getFareFamilyName(dictionary: IFareFamilyDictionary): string{
        return this.fareFamilyService.getName(dictionary.name || {value: dictionary.code, languageCode: 'fr'});
    }

    public getCurrentPriceForDelta(data: {
        value: string | number;
        priceDifference?: string;
        currencyCode?: string;
        decimals?: number;
    }): { [key: string]: number; } {
        return { [data.currencyCode]: data.value as number };
    }

    public closeModal(): void{
        this.dialogRef.close();
    }

    public trackByfn(index: number): number{
        return index;
    }

    private getSelectedFareFamily(): void {
        if(this.data.length === 0){
            this.selectedFareFamily = null;
        }
        this.selectedFareFamily = getSelectedFareFamilyInData(this.data);
    }
}

function getSelectedFareFamilyInData(data: IFareFamilyDialogData[]): {
    xId: string,
    price: { [key: string]: number; };
    currency: { code: string; decimals: number; }
} {
    const dataSelection : IFareFamilyDialogData = data.find((item: IFareFamilyDialogData): boolean => item.isSelected);
    return {
        xId: dataSelection.dictionary.xId,
        currency: dataSelection.price ? {
            code: dataSelection.price.currencyCode,
            decimals: dataSelection.price.decimals
        } : null,
        price: dataSelection.price ?  { [dataSelection.price.decimals]: dataSelection.price.value as number} : null,
    };
}
